module.exports = __webpack_public_path__ + "static/anti-ragging-f69afa9f97f2d783c831c15f68388dcc.pdf";